import m from "./../../../dist/es2015/themes/Dark.js";
export const am5themes_Dark = m;